import { initializeApp, getApps, getApp, FirebaseApp } from "firebase/app";
import { getMessaging, isSupported, Messaging } from "firebase/messaging";
import firebaseConfig from "../../config/firebaseConfig";

// Initialize the Firebase app exactly once. Every other module imports the
// singleton from here; nothing else should call initializeApp().
export const firebaseApp: FirebaseApp = getApps().length
  ? getApp()
  : initializeApp(firebaseConfig);

let messagingInstance: Messaging | null = null;

/**
 * Returns the FCM Messaging instance, or null when the current environment
 * does not support web push (e.g. unsupported browser, or an Android WebView
 * where push is handled natively). Guarded by isSupported() so callers never
 * throw on unsupported platforms.
 */
export async function getMessagingInstance(): Promise<Messaging | null> {
  try {
    if (!(await isSupported())) return null;
    if (!messagingInstance) {
      messagingInstance = getMessaging(firebaseApp);
    }
    return messagingInstance;
  } catch (error) {
    console.warn("Firebase messaging unavailable:", error);
    return null;
  }
}
